import moment from "moment";
export function convertDateTime(date: any, format: string) {
  return moment(date).format(format);
}
